import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        menu: [],
        company:{},
        keyword : '',
    },
    mutations: {
        setMenu(state, value) {
            state.menu  = value
        },
        setCompany(state, value) {
            state.company = value
        },
        setKeyword(state, value) {
            state.keyword = value
        }
    },
    actions: {
        setMenu({commit}, value) {
            commit('setMenu', value)
        },
        setCompany({commit}, value) {
            commit('setCompany', value)
        },
        setKeyword({commit}, value) {
            commit('setKeyword', value)
        }
    },
    getters: {
        getMenu(state) {
            return state.menu
        },
        getCompany(state) {
            return state.company
        },
        getKeyword(state) {
            return state.keyword
        }
    }
})
export default store;

